import { render, staticRenderFns } from "./KeypadIcon.vue?vue&type=template&id=d5fb4cb8&scoped=true&"
import script from "./KeypadIcon.vue?vue&type=script&lang=js&"
export * from "./KeypadIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5fb4cb8",
  null
  
)

export default component.exports